<template>
  <div >
    <Row :gutter="16" style="margin-left:0;" type="flex">
      <Col style="margin-top:30px;padding:0 20px;" v-for="(item,index) in historyList" :key="index">
        <Card  :padding='0' style="width: 280px;height:360px" dis-hover>
          <div class="picDiv" :style="{backgroundImage:'url('+item.coverPicUrl+')'}"></div>
          <div class="info-wrapper">
            <div class="info slh" :title="item.title">{{item.title}}</div>
            <div class="info-time">{{item.sendDate}}</div>
          </div>
          <div class="send-sate">
            <div class="jieshou">成功接收人数：{{item.receiveNumber }}人</div>

            <div v-if="item.sendType == '2'" class="dian zhuangtai">
              <div class="iconfont icon-sangedian zhuangtai-icon"></div>
              <div>发送中</div>
            </div>
            <div v-else-if="item.sendType == '1'" class="chenggong zhuangtai">
              <div class="iconfont icon-tubiaozhizuomoban zhuangtai-icon"></div>
              <div>发送成功</div>
            </div>
            <div v-else-if="item.sendType == '0'" class="zhuangtai">
              <div class="iconfont icon-quxiao zhuangtai-icon"></div>
              <div >发送失败</div>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
  var that
  export default {
    name: "historyCard",
    components: {
    },
    props: {
      historyList: {
        type: Array,
        default: [1,2,3,4,5]
      }
    },
    data() {
      return {
      }
    },
    methods: {
      cardHover (index) {
        that.adminList[index].showCha = true
      },
      cardOut (index) {
        that.adminList[index].showCha = false
      },
      clickCha (index) {
        that.$emit("delAdmin",index)
      }
    },
    created() {
      that = this;
    }
  };
</script>

<style scoped lang="less">
.picDiv{
  height:170px;
  width: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
  .info-wrapper{
    height:100px;
    border-bottom: 1px solid #eeeeee;
    padding: 30px 20px 20px 20px ;
    position: relative;
  }
  .info{
    color: #4b4b4b;
    font-size: 17px
  }
  .info-time{
    color:#999999;
    font-size: 13px;
    position: absolute;
    bottom: 22px;
    right:20px
  }
  .send-sate{
    display: flex;
    flex-flow: column;
    justify-content:center;
    text-align: center;

  }
  .jieshou{
    height:15px;
    line-height: 15px;
    margin-top:20px;
    color:#999999;
  }
  .zhuangtai{
    display: flex;

    margin-top: 10px;
    height: 15px;
    line-height: 15px;
    justify-content: center;
  }
  .zhuangtai-icon{
    font-size:15px;
    padding-right:10px;
  }
.dian{
  color: #ff7b44;
}
  .chenggong{
    color:#47ba53
  }
  .shibai{
    color:#d22b2b
  }

</style>
